export default {
  STATE_KEYS: {
    DECODE_QUERY_PARAMS: "decode_query_params",
    DECODE_RESULTS: "decode_results",
    MATRIX: "matrix",
  },
  MUTATIONS: {
    SHARED: {
      UPDATE_VALUE: "update_value",
      ADD_TO_LIST: "add_to_list",
      REMOVE_FROM_LIST: "remove_from_list",
      RESET_STATE: "reset_state",
      DEFINE_STATE: "define_state",
    },
    DECODE_RESULTS: {
      ADD_RESULTS: "add_results",
      SELECT_RESULT: "select_result",
      DESELECT_RESULT: "deselect_result",
      UPDATE_PROGRESS: "update_progress",
      ADD_CUSTOM_RESULT: "add_custom_result",
      REMOVE_CUSTOM_RESULT: "remove_custom_result",
    },
    MATRIX: {
      SET_STATE: "set_state",
      UPDATE_TOOL_VALUE: "update_tool_value",
      UPDATE_MATRIX_SEARCH_PROGRESS: "update_matrix_search_progress",
      ADD_MATRIX_RESULTS: "add_matrix_results",
    },
  },
};
